<template>
  <div class="no-data">
    <img alt src="../../assets/img/no-oder.png" />
    <p>暂无售后订单</p>
  </div>
</template>

<script>
export default {
  name: 'noData'
}
</script>

<style lang="less" scoped>
.no-data {
  text-align: center;
  padding-top: 2.1rem;
  img {
    width: 4.49rem;
    height: 3.04rem;
  }
  p {
    font-size: @fz28;
    color: @base;
    margin-top: -1rem;
  }
  .go-shoping {
    width: 1.93rem;
    height: 0.6rem;
    color: @base;
    font-size: @fz24;
    // border: 0.5px solid #979797;
    // border-radius: 30px;
    .hairline-surround(@color: #979797);
    margin-top: 0.7rem;
  }
}
</style>
